// @ts-nocheck
import * as React from "react";

const Pinterest: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
            <g fill="currentColor" clipPath="url(#a)">
                <path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.741 24.741A13.69 13.69 0 0 1 15 28.777a13.68 13.68 0 0 1-9.742-4.036A13.69 13.69 0 0 1 1.223 15c0-3.68 1.432-7.14 4.035-9.742A13.69 13.69 0 0 1 15 1.223c3.68 0 7.14 1.432 9.741 4.035A13.69 13.69 0 0 1 28.777 15c0 3.68-1.432 7.14-4.036 9.741Z" />
                <path d="M15.443 5.622a9.338 9.338 0 0 0-3.218.566 7.358 7.358 0 0 0-3.428 2.554C7.355 10.7 7 13.638 8.599 15.615c.293.36 1.204 1.325 1.674.747.098-.12.142-.274.175-.426.095-.43.247-.838-.063-1.23-1.565-1.963-.352-5.277 1.733-6.366 1.099-.576 2.347-.909 3.59-.804 1.016.084 2.018.48 2.788 1.15.864.753 1.256 1.808 1.256 2.944 0 .692-.07 1.358-.205 1.977-.464 2.148-1.677 3.717-3.303 3.717-1.022 0-1.944-.813-1.779-1.882.205-1.33 2.355-5.589-.484-5.589-1.006 0-1.677.708-1.938 1.63a4.469 4.469 0 0 0-.149 1.437c.023.482.221.932.259 1.395.016.208-.045.422-.094.62-.377 1.516-.8 3.025-1.138 4.548-.333 1.495-.291 2.366.04 3.877.07.317.162.301.377.094.365-.357.65-.832.915-1.265.36-.589.663-1.215.901-1.865.377-1.03.352-1.43.629-2.49.384.71 1.509 1.335 2.704 1.335a5.446 5.446 0 0 0 3.626-1.363c1.064-.945 1.735-2.3 2.082-3.67.63-2.485.132-5.056-1.868-6.756-1.353-1.15-3.12-1.751-4.888-1.763l.004.005Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h30v30H0z" />
                </clipPath>
            </defs>
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Pinterest);
